import { useEffect, useState, useCallback } from 'react'
import delve from 'dlv'

import Script from 'next/script'
import { useRouter } from 'next/router'
import Head from 'next/head'
import FastSpringCheckout from 'components/pages/fastspring/checkout/popup'

import type { FC } from 'react'
import { getNamedPageStaticProps } from 'lib/staticProps'

declare global {
  var fastspring: any
  var onFSWebhookReceived: any
  var getFastSpringTags: any
}

interface Props {
  content: any
  global: any
}

const CheckoutFs: FC<Props> = ({ content, global }) => {
  const router = useRouter()
  const [isScriptLoaded, setScriptLoaded] = useState<boolean>(false)
  const { storefront, defaultSku } = global.fastspring
  const { title } = delve(content, 'data.attributes')

  const showPopupStorefront = useCallback(() => {
    const skuParam = router.query.sku
    const sku = skuParam || defaultSku

    window.fastspring.builder.reset()
    window.fastspring.builder.add(sku)
    window.fastspring.builder.tag({ storefront, ...getFastSpringTags() })
    window.fastspring.builder.checkout()
  }, [defaultSku, storefront, router.query.sku])

  const onScriptLoaded = () => {
    setScriptLoaded(true)
  }

  useEffect(() => {
    if (router.isReady && isScriptLoaded) {
      showPopupStorefront()
    }
  }, [router.isReady, isScriptLoaded, showPopupStorefront])

  function onWebhookReceived(data: any) {
    if (data && data.id) {
      window.fastspring.builder.reset()
      window.location.href = '/purchase/fs/complete?orderId=' + data.id
    }
  }

  if (typeof window !== 'undefined') {
    window.onFSWebhookReceived = onWebhookReceived
  }

  return (
    <>
      <Head>
        <title key="title">{title}</title>
      </Head>
      <FastSpringCheckout
        global={global}
        content={content}
        showPopupStorefront={showPopupStorefront}
      />
      <Script
        id="fsc-api"
        type="text/javascript"
        src="https://d1f8f9xcsvx3ha.cloudfront.net/sbl/0.9.2/fastspring-builder.min.js"
        data-storefront={storefront}
        data-popup-webhook-received="onFSWebhookReceived"
        onLoad={onScriptLoaded}
      />
    </>
  )
}

export const getStaticProps = getNamedPageStaticProps(
  'checkout-fs',
  'blocks.fast-spring-popup-checkout'
)

export default CheckoutFs
